
import * as handlebars_family from "./handlebars_family.ts";
import "./widget/action-menu.ts";
const TPL = handlebars_family.addTemplate("smiley-dropdown",{"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<icon data-widget=\"widget/action-menu\" data-key=\"emojitext\">"
    + container.escapeExpression((lookupProperty(helpers,"iconlib")||(depth0 && lookupProperty(depth0,"iconlib"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"ic_add_emoji",{"name":"iconlib","hash":{},"data":data,"loc":{"start":{"line":1,"column":60},"end":{"line":1,"column":86}}}))
    + "</icon>";
},"useData":true});
export default TPL;